﻿function isTouchDevice() {
  return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
  );
}

class MiniCardSlider {
  constructor() {
    this.counter = 0;
    this.element = document.querySelector(".summary__cards-section");

    if (!this.element) {
      return;
    }

    this.sliderItems = this.element.querySelectorAll(".slideshow__card");
    this.sliderLength = this.sliderItems.length - 1;
    this.sliderWidth = this.sliderItems[0].clientWidth;
    this.slidesContainer = this.element.querySelector(".carousel--flyover-homes");
    this.prevButton = this.element.querySelector(".left--arrow");
    this.nextButton = this.element.querySelector(".right--arrow");
    
    // Prevent initilization
    if (!this.initSlider()) {    
      return;
    }

    this.prevButton?.addEventListener("click", () => {      
      if (this.counter >= 1) {
        this.counter -= 1;         
        this.scrollIntoView();
      }      
    });

    this.nextButton?.addEventListener("click", () => {           
      if (this.counter < this.sliderLength) {
        this.counter += 1;       
        this.scrollIntoView();
      }
    });

    const reportWindowSize = () => {      
      this.counter = 1;
      this.scrollIntoView();
    };

    this.checkArrowButtons();
    window.onresize = reportWindowSize;
  }


  isSliderDisable() {
    return this.element.scrollWidth >= this.sliderWidth * (this.sliderLength + 1)
  }

  initSlider() {             
    if (this.isSliderDisable() || isTouchDevice()) {
      return false;
    }
    return true;
  }  
  
  checkArrowButtons() {
    if (this.counter === 0) {
      this.prevButton?.setAttribute("disabled", true);
    } else {
      this.prevButton?.removeAttribute("disabled");
    }  

    if (this.counter === this.sliderLength) {
      this.nextButton?.setAttribute("disabled", true);
    } else {
      this.nextButton?.removeAttribute("disabled");
    }
  }

  scrollIntoView() {  
    const currentElement = this.sliderItems[this.counter];
    currentElement.scrollIntoView({ behavior: "smooth", inline: "center" });
    this.checkArrowButtons();
  }
}

export default MiniCardSlider;
